import api from "./Api";

class EstoqueImagemService {
  GetEstoqueImagem(payload) {
    return api.get("/v1/estoqueImagem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEstoqueImagem(payload) {
    return api.post("/v1/estoqueImagem/", payload).then((response) => {
      return response.data;
    });
  }

  PutEstoqueImagem(payload) {
    return api.put("/v1/estoqueImagem/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEstoqueImagem(payload) {
    return api.delete("/v1/estoqueImagem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEstoqueImagemOData(payload) {
    return api.get("/OData/EstoqueImagem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EstoqueImagemService();
